import { Avatar, Card, CardActionArea, CardContent, Grid, Paper, Typography } from "@mui/material";
import { MenuBook as MenuBookIcon } from "@mui/icons-material";

export default function MenusList({ t, data, selectInstance }) {
  return (<>
    <Paper sx={{ padding: 3, margin: "0 auto" }}>
      {data !== null && data.length !== 0 ? <>
        <div style={{ marginBottom: 1 }}>
          <Typography gutterBottom variant="body1" component="div"> {t('designmenu_page_instructions')} </Typography>
        </div>
        <Grid container spacing={2}>
          {data.map((item) => (
            <Grid key={item._id} item xs={12} md={6}>
              <Card onClick={() => selectInstance(item)} sx={{ border: "1px solid #212145", borderRight: "5px solid #212145" }}>
                <CardActionArea>
                  <CardContent>
                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                      <div style={{ margin: "0px 8px" }}>
                        <Avatar sx={{ bgcolor: "#212145" }}> <MenuBookIcon sx={{ color: "#ffffff" }} /> </Avatar>
                      </div>
                      <div style={{ margin: "0px 8px" }}>
                        <Typography gutterBottom variant="subtitle1" component="div" sx={{ fontWeight: 600 }}> {item.name} </Typography>
                      </div>
                    </div>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      </> : null}
    </Paper>
  </>)
}